import React from 'react';
import Head from 'next/head';
import Script from 'next/script';

import { MetaElement, MetaElementsFields } from './meta-elements.type';

export const OASMetaElements: React.FC<MetaElementsFields> = ({ fields }) => {
  if (!fields || !fields.elements || fields.elements.length === 0) {
    return null;
  }

  const { scripts, other } = fields.elements.reduce<{
    scripts: MetaElement[];
    other: MetaElement[];
  }>(
    (acc, element) => {
      if (element.tag === 'script') {
        acc.scripts.push(element);
      } else {
        acc.other.push(element);
      }
      return acc;
    },
    { scripts: [], other: [] }
  );

  return (
    <>
      <Head>
        {other.map((element, index) => (
          <element.tag key={`${element.id}-${index}`} {...element.attributes} />
        ))}
      </Head>
      {scripts.map((script, index) => (
        <Script
          key={`${script.id}-${index}`}
          id={`${script.id}-${index}`}
          src={script.attributes.src}
          strategy={
            script.attributes.strategy as
              | 'afterInteractive'
              | 'lazyOnload'
              | 'beforeInteractive'
              | 'worker'
              | undefined
          }
          onLoad={() => {
            if (script.attributes.onLoad) {
              eval(script.attributes.onLoad);
            }
          }}
        />
      ))}
    </>
  );
};
